import React, { Component } from 'react';
import { Divider, HTMLTable, Button, Intent, Tag } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class WebDownloads extends Component {
  constructor(props) {
    super(props);
    this.state = {
      links: [
        { name: 'Full Client v4.2 (Google Drive)', size: '3.8 GB', mirror: 'Google Drive Mirror #1', speed: 'Fast (1 Gbps)', status: 'ONLINE' },
        { name: 'Full Client v4.2 (Mega.nz)', size: '3.8 GB', mirror: 'Mega Cloud Mirror', speed: 'Fast (500 Mbps)', status: 'ONLINE' },
        { name: 'Full Client v4.2 (Torrent)', size: '3.8 GB', mirror: 'P2P Torrent Seed', speed: 'Unlimited', status: 'ONLINE' },
        { name: 'Manual Security Patch v4.2.0', size: '42 MB', mirror: 'Direct CDN Host', speed: 'Ultra-Fast', status: 'ONLINE' },
      ]
    };
  }

  render() {
    return (
      <SideMenuWrapper>
        <h3 className="display-4 font-italic mb-3" style={{ fontSize: '1.5rem', color: '#182026' }}>
          Client Downloads & Patch Mirrors
        </h3>
        <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
          Manage download links for players, client mirrors, manual patch files, and anticheat updates.
        </p>

        <Divider className="mb-4" />

        <HTMLTable bordered condensed striped style={{ width: '100%', fontSize: '0.82rem' }}>
          <thead>
            <tr>
              <th style={{ color: '#182026' }}>File Package Name</th>
              <th style={{ color: '#182026' }}>File Size</th>
              <th style={{ color: '#182026' }}>Mirror Server</th>
              <th style={{ color: '#182026' }}>Speed Grade</th>
              <th style={{ color: '#182026' }}>Status</th>
              <th style={{ color: '#182026' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {this.state.links.map((dl, i) => (
              <tr key={i}>
                <td className="font-weight-bold" style={{ color: '#182026' }}>{dl.name}</td>
                <td className="font-mono text-warning font-weight-bold">{dl.size}</td>
                <td style={{ color: '#106ba3' }}>{dl.mirror}</td>
                <td style={{ color: '#5c7080' }}>{dl.speed}</td>
                <td><Tag intent={Intent.SUCCESS} round>{dl.status}</Tag></td>
                <td><Button icon="cloud-download" small minimal intent={Intent.PRIMARY} text="Test Link" /></td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>
      </SideMenuWrapper>
    );
  }
}
